export default __webpack_public_path__ + "static/media/600px-Headshot.jpg.9424c3e0.webp";